import React, {useMemo} from "react";
import {safeHTML} from "../../utils/safeHTML";
import classNames from "classnames";
import {useRouter} from "next/router";
import styles from "./Zodiacs.module.scss";


const Zodiacs = React.forwardRef(
  function Zodiacs(props, ref) {
    const {setActiveZodiac, tabs: {zodiacs}, horoscope, className} = props;


    const zodiacsList = useMemo(() => {
      return zodiacs.map((item, index) => {
        const {slug} = item
        const moreInfo = horoscope?.zodiacs?.find((item) => item?.zodiacSign.slug === slug)
        return moreInfo ? {...moreInfo, ...item, active: true} : {...item, active: false}
      })
    }, [horoscope])

    const router = useRouter();

    const onClick = (href) => {
      router.push(href)
    }

    return (
      <section className={classNames(styles.zodiacs, className)} ref={ref}>
        <div className={styles.zodiacs__content}>
          <ul className={styles.zodiacs__list}>
            {zodiacsList?.map(({title, dates, slug, image: icon, href, active}, index) => {
              console.log(active)
              const isFetchpriority = index < 4;
              return (
                <li className={classNames(styles.zodiacs__item, {
                  [styles.zodiacs__item_active]: active
                })}
                    key={`zodiac-${index}`}
                    onClick={() => {
                      if (href) onClick(href)
                      setActiveZodiac(slug)
                    }}
                >
                  <div className={styles.zodiacs__itemIcon}>
                    <img src={icon} alt={title} width={110} height={110}
                         fetchpriority={isFetchpriority ? "high" : "auto"}
                         loading={isFetchpriority ? "eager" : "lazy"}
                    />
                  </div>
                  <div className={styles.zodiacs__itemTitle}>{safeHTML(title)}</div>
                  <div className={styles.zodiacs__itemDates}>{safeHTML(dates)}</div>
                </li>)
            })}
          </ul>
        </div>

      </section>
    );
  });
export default Zodiacs;
Zodiacs.propTypes = {};

